/**
 * Created by yousefJbour on 8/13/18.
 */
(function (angular) {

    "use strict";
    angular
        .module('harriApp')
        .controller('HMAPAtrsListingsController', ["$scope", "$state", "$stateParams", "hmapService", function ($scope, $state, $stateParams, hmapService) {
            $scope.activeBrandId = hmapService.getActiveBrand();

            ATRAPI.getBrandSettings($scope.activeBrandId)
                .then(function (atrSetting) {
                    $scope.atrType = atrSetting.atr_type;
                })
                .catch(function (err) {
                    console.error(err);
                });

            $scope.onAtrEdit = function (atrBrandId, atrId) {
                var params = {
                    hmapPath: $stateParams['hmapPath']
                };

                if (atrBrandId && atrId) {
                    params['atr_id'] = atrId;
                    params['brand_id'] = atrBrandId;
                }

                $state.go("appLayout.harriSH.access-portal.atrs-manage", params);
            }
        }]);

})(angular);
